var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 2.25L6.75 11.25V24.75C6.75 37.2375 15.39 48.915 27 51.75C38.61 48.915 47.25 37.2375 47.25 24.75V11.25L27 2.25ZM22.5 38.25L13.5 29.25L16.6725 26.0775L22.5 31.8825L37.3275 17.055L40.5 20.25L22.5 38.25Z",
    fill: "#0F7FEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.676e2142c7c87a63ae118cad7a8223ef.svg";
export { ForwardRef as ReactComponent };